import { Icon, SlimButton, Tooltip } from 'components'

import * as S from './styles'

interface TopBarProps {
  onEditClick: () => void
  onCancelEditClick: () => void
  onSaveEditClick: () => void
  onDownloadClick: () => void
  onTrackingClick: () => void
  canEdit: boolean
  isEditing: boolean
  isWaitingForApproval: boolean
  editButtonDisabled?: boolean
  saveButtonDisabled?: boolean
  downloadButtonDisabled?: boolean
  trackingButtonDisabled?: boolean
  disabled?: boolean
}

const ICON_SIZE = '15'

export const TopBar = ({
  onEditClick,
  onCancelEditClick,
  onSaveEditClick,
  onDownloadClick,
  onTrackingClick,
  canEdit = false,
  isEditing = false,
  isWaitingForApproval = false,
  editButtonDisabled = false,
  saveButtonDisabled = false,
  downloadButtonDisabled = false,
  trackingButtonDisabled = false,
  disabled = false,
}: TopBarProps) => {
  return (
    <S.Container>
      <SlimButton
        content="Baixar"
        data-testid="download-button"
        disabled={disabled || isEditing || downloadButtonDisabled}
        icon={<Icon icon="download" size={ICON_SIZE} />}
        onClick={onDownloadClick}
        variant="ghost"
      />
      <SlimButton
        content="Tracking"
        data-testid="tracking-button"
        disabled={disabled || isEditing || trackingButtonDisabled}
        icon={<Icon icon="track" size={ICON_SIZE} />}
        onClick={onTrackingClick}
        variant="ghost"
      />

      {canEdit && (
        <>
          <S.ColDivider />
          {isEditing ? (
            <>
              <SlimButton
                content="Cancelar"
                disabled={disabled}
                icon={<Icon icon="arrow-left" size={ICON_SIZE} />}
                onClick={onCancelEditClick}
                variant="secondary"
              />
              <SlimButton
                content="Salvar"
                disabled={disabled || saveButtonDisabled}
                icon={<Icon icon="save" size={ICON_SIZE} />}
                onClick={onSaveEditClick}
                variant="primary"
              />
            </>
          ) : (
            <Tooltip
              arrow
              disableHoverListener={!isWaitingForApproval}
              placement="top"
              title={'Não é possível editar enquanto estiver no aguardo de aprovação'}
            >
              <div>
                <SlimButton
                  content="Editar"
                  disabled={disabled || editButtonDisabled || isWaitingForApproval}
                  icon={<Icon icon="edit" size={ICON_SIZE} />}
                  onClick={onEditClick}
                  variant="primary"
                />
              </div>
            </Tooltip>
          )}
        </>
      )}
    </S.Container>
  )
}
